const educationData = {
  pgdm: {
    title: "Post Graduate Diploma in Management (PGDM)",
    institution: "Calcutta Business School",
    session: "2026-2028",
  },
  btech: {
    title: "Bachelor of Technology",
    institution: "Gargi Memorial Institute of Technology",
    university: "Maulana Abul Kalam Azad University of Technology",
    cgpa: "9.28 CGPA ( 85.30 % )",
    sgpa: [
      { label: "1st Semester SGPA", value: "9.71 SGPA" },
      { label: "2nd Semester SGPA", value: "9.90 SGPA" },
      { label: "3rd Semester SGPA", value: "9.55 SGPA" },
      { label: "4th Semester SGPA", value: "9.67 SGPA" },
      { label: "5th Semester SGPA", value: "8.75 SGPA" },
      { label: "6th Semester SGPA", value: "8.73 SGPA" },
      { label: "7th Semester SGPA", value: "9.33 SGPA" },
      { label: "8th Semester SGPA", value: "8.60 SGPA" },
    ],
    referencePath: "/referencebtech",
    session: "2020-2024",
  },
  hs: {
    title: "Higher Secondary (XII)",
    institution: "Haldia Govt. Spons. Vivekananda Vidyabhawan",
    board: "West Bengal Council of Higher Secondary Education (WBCHSE)",
    percentage: "90%",
    referencePath: "/referencehs",
    year: "2020",
  },
  secondary: {
    title: "Secondary (X)",
    institution: "Vivekananda Mission Asram Sikshayatan",
    board: "West Bengal Board of Secondary Education (WBBSE)",
    percentage: "89.9%",
    referencePath: "/referencesec",
    year: "2018",
  },
};

export default educationData;
